// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.
 
 
import type { FC } from 'react';

import { Icon, type IconProps } from './../../IconWrapper';

const SvgChevronUpIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <path
      fillRule="evenodd"
      d="m7.839 14.757 4.166-4.166 4.167 4.166a1.07 1.07 0 1 0 1.514-1.514l-4.929-4.929a1.07 1.07 0 0 0-1.514 0l-4.929 4.929a1.07 1.07 0 0 0 0 1.514 1.09 1.09 0 0 0 1.525 0"
    />
  </Icon>
);
export default SvgChevronUpIcon;
SvgChevronUpIcon.displayName = 'SvgChevronUpIcon';
